/* RetryableButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./RetryableButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { FormattedMessage } from 'react-intl-next';
import AkButton from '@atlaskit/button/new';
import Spinner from '@atlaskit/spinner';
import { Box } from '@atlaskit/primitives/compiled';
import { messages } from '../i18n';
var buttonSpinner = null;
export var retryUploadButtonTestId = 'retry-upload-button';
export var uploadEmojiButtonTestId = 'upload-emoji-button';
var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_2hwx19bv _18u019bv"])
  }, /*#__PURE__*/React.createElement(Spinner, null));
};
var RetryButton = function RetryButton(props) {
  var onSubmit = props.onSubmit,
    ariaLabelledBy = props.ariaLabelledBy,
    ariaDescribedBy = props.ariaDescribedBy;
  return /*#__PURE__*/React.createElement(FormattedMessage, messages.retryLabel, function (retryLabel) {
    return /*#__PURE__*/React.createElement(Box, {
      paddingInlineEnd: "space.050"
    }, /*#__PURE__*/React.createElement(AkButton, {
      appearance: "warning",
      onClick: onSubmit,
      testId: retryUploadButtonTestId,
      "aria-describedby": ariaDescribedBy,
      "aria-labelledby": ariaLabelledBy,
      autoFocus: true
    }, retryLabel));
  });
};
var UploadButton = function UploadButton(props) {
  var appearance = props.appearance,
    onSubmit = props.onSubmit,
    label = props.label,
    ariaLabelledBy = props.ariaLabelledBy,
    ariaDescribedBy = props.ariaDescribedBy;
  return /*#__PURE__*/React.createElement(Box, {
    paddingInlineEnd: "space.050"
  }, /*#__PURE__*/React.createElement(AkButton, {
    appearance: appearance,
    onClick: onSubmit,
    testId: uploadEmojiButtonTestId,
    "aria-describedby": ariaDescribedBy,
    "aria-labelledby": ariaLabelledBy,
    autoFocus: true
  }, label));
};
var RetryableButton = function RetryableButton(props) {
  var loading = props.loading,
    error = props.error;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingSpinner, null);
  }
  if (error) {
    return /*#__PURE__*/React.createElement(RetryButton, props);
  }
  return /*#__PURE__*/React.createElement(UploadButton, props);
};
export default RetryableButton;